import React from 'react';
import AgreementTemplatesPageContent from '../../AgreementTemplates/Components/AgreementTemplatesPageContent';

export default function AgreementTemplatesPage() {
    return <AgreementTemplatesPageContent />;
}
